import { Component, inject, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { LanguageService, StorageService } from '@trading-fe/services';
import { ThemeService } from './services/theme.service';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnDestroy {
  private languageService = inject(LanguageService);
  private themeService = inject(ThemeService);
  private router = inject(Router);
  private storage = inject(StorageService);

  private onPageShow = (event: PageTransitionEvent) => {
    if (event.persisted) {
      // Page was restored from bfcache — re-check auth state
      this.router.navigateByUrl(this.router.url, { replaceUrl: true });
    }
  };

  constructor() {
    this.languageService.init();
    this.themeService.init();
    window.addEventListener('pageshow', this.onPageShow);
  }

  ngOnDestroy(): void {
    window.removeEventListener('pageshow', this.onPageShow);
  }
}
